import styles from "./search-form-filter-row.less";

type SearchFormFilterRowProps = {
    children: React.ReactNode | Array<React.ReactNode>;
};

export const SearchFormFilterRow = (props: SearchFormFilterRowProps) => {
    const { children } = props;

    return (
        <div className={styles.searchFormFilterRow}>
            {children}
        </div>
    );
};